import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";
import ErrorBoundary from './components/ErrorBoundary';
import {
  clearAssetRecoveryQueryMarker,
  installGlobalAssetLoadRecovery,
} from './utils/assetLoadRecovery';

clearAssetRecoveryQueryMarker();
installGlobalAssetLoadRecovery();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
